import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import useDebouncedCallback from 'hooks/useDebouncedCallback';
import { toTitleCase } from "utils/common";

export default function useEmployeeFilter(pageSettings , setPageSettings) {
    const [searchParams] = useSearchParams();
    const {
        department, departmentLoading,
        reportTo, reportToLoading,
        nationality, nationalityLoading,
        position, positionLoading,
        division, divisionLoading,
        costCenter, costCenterLoading
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
    // Tracks whether the drawer's draft filters differ from what was last
    // applied/searched, so "Apply Filters" only lights up when there's
    // something new to submit.
    const [isFilterDirty, setIsFilterDirty] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
    {
        key: "employment_date_after",
        label: "Joined after",
        value: searchParams.get("employment_date_after") || ""
    },
    {
        key: "employment_date_before",
        label: "Joined before",
        value: searchParams.get("employment_date_before") || ""
    },
    {
        key: "gender",
        label: toTitleCase(searchParams.get("gender") || ""),
        value: searchParams.get("gender") || ""
    },
    {
        key: "report_to",
        label: "",
        value: searchParams.get("report_to") || ""
    },
    {
        key: "department",
        label: "",
        value: searchParams.get("department") || ""
    },
    {
        key: "nationality",
        label: "",
        value: searchParams.get("nationality") || ""
    },
    {
        key: "position",
        label: "",
        value: searchParams.get("position") || ""
    },
    {
        key: "division",
        label: "",
        value: searchParams.get("division") || ""
    },
    {
        key: "marital_status",
        label: toTitleCase(searchParams.get("marital_status") || ""),
        value: searchParams.get("marital_status") || ""
    },
    {
        key: "cost_center",
        label: toTitleCase(searchParams.get("cost_center") || ""),
        value: searchParams.get("cost_center") || ""
    },
    {
        key: "status",
        label: toTitleCase(searchParams.get("status") || ""),
        value: searchParams.get("status") 
    },
    {
        key: "eos_approved",
        label: toTitleCase(searchParams.get("eos_approved") || ""),
        value: searchParams.get("eos_approved") || ""
    },
    {
        key: "resigned_date_after",
        label: "Resigned after",
        value: searchParams.get("resigned_date_after") || ""
    },
    {
        key: "resigned_date_before",
        label: "Resigned before",
        value: searchParams.get("resigned_date_before") || ""
    }
  ]);

  useEffect(()=>{

    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading && !costCenterLoading && department.length && reportTo.length && nationality.length && position.length && division.length){
        let gender = searchParams.get("gender") || ""
        let nationalityParams = searchParams.get("nationality") || ""
        // console.log(nationalityParams, "nationalityParams", searchParams.getAll("nationality"))

        if(nationalityParams){
            nationalityParams = nationalityParams.split(",")
        }else{
            nationalityParams = []
        }
        console.log(nationalityParams, "nationality")

        let reportToId = searchParams.get("report_to") || ""
        let selectedReportTo = reportToId ? reportTo.find(item=>item.user_id == reportToId) : null
        
        let deptId = searchParams.get("department") || ""
        let selectedDepartment = deptId ? department.find(item=>item.id == deptId) : null
        
        let selectedNationality = nationality.filter(item=> nationalityParams.includes(item.id.toString()))
        console.log(selectedNationality, nationality,nationalityParams,"selectedNationality")
        
        let positionId = searchParams.get("position") || ""
        let selectedPosition = positionId ? position.find(item=>item.id == positionId) : null
        
        let divisionId = searchParams.get("division") || ""
        let selectedDivision = divisionId ? division.find(item=>item.id == divisionId) : null
        
        let selectedMarital = searchParams.get("marital_status") || ""
        
        let costCenterId = searchParams.get("cost_center") || ""
        let selectedCostCenter = costCenterId && costCenter?.length ? costCenter.find(item=>item.id == costCenterId) : null
        
        let selectedStatus = searchParams.get("status") || ""
        let selectedEos = searchParams.get("eos_approved") || ""
        console.log(selectedStatus, "---SELECTED STATUS")
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "employment_date_after",
                label: "Joined after",
                value: searchParams.get("employment_date_after") || ""
            },
            {
                key: "employment_date_before",
                label: "Joined before",
                value: searchParams.get("employment_date_before") || ""
            },
            {
                key: "gender",
                label: "", // Don't show label for gender
                value: gender || ""
            },
            {
                key: "report_to",
                label: "", // Don't show label for report_to
                value: searchParams.get("report_to") || ""
            },
            {
                key: "department",
                label: "", // Don't show label for department
                value: searchParams.get("department") || ""
            },           
            {
                key: "position",
                label: "", // Don't show label for position
                value: searchParams.get("position") || ""
            },
            {
                key: "division",
                label: "", // Don't show label for division
                value: searchParams.get("division") || ""
            },
            {
                key: "marital_status",
                label: "", // Don't show label for marital status
                value: selectedMarital
            },
            {
                key: "cost_center",
                label: "", // Don't show label for cost center/store
                value: costCenterId
            },
            {
                key: "status",
                label: selectedStatus == "all" ? "All" : (selectedStatus == "true" ? "Active" : selectedStatus == "false" ? "Inactive" : ""),
                value: selectedStatus || ""
            },
            {
                key: "eos_approved",
                label: toTitleCase(selectedEos),
                value: selectedEos || ""
            },
            {
                key: "resigned_date_after",
                label: "Resigned after",
                value: searchParams.get("resigned_date_after") || ""
            },
            {
                key: "resigned_date_before",
                label: "Resigned before",
                value: searchParams.get("resigned_date_before") || ""
            }
          ]

          if(selectedNationality.length){
            let nationalities = selectedNationality.map(item => {
                return { value: item.id,
                label: item.name}
            })
            _filters.push(
                {
                    key: "nationality",
                    label: "Nationality",
                    value: nationalities
                },
            )

          }else{
            _filters.push(
                {
                    key: "nationality",
                    label: "Nationality",
                    value: ""
                }
            )
          }
          setFilters(_filters)
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division,
    costCenter,
    departmentLoading,
    divisionLoading,
    nationalityLoading,
    positionLoading,
    reportToLoading,
    costCenterLoading,
    searchParams
  ])

  const handleFilterChange =  (data, key, make_call=false) => {

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    
    // console.log(data , "====data")
    // console.log(_filters , "====_filters")

    if(Array.isArray(data)){
        // selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data

    }else{
        selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data?.value ?? ""
    }


    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }



  };
  // Use ref to always have access to latest values without causing re-renders
  const pageSettingsRef = useRef(pageSettings);

  useEffect(() => {
    pageSettingsRef.current = pageSettings;
  }, [pageSettings]);

  const handleInputChange = useDebouncedCallback((data, key, make_call=false) => {
    // Use functional update to get the latest filters
    setFilters(prevFilters => {
      const _filters = [...prevFilters]
      const selectedFilter = _filters.find(item=> item.key === key)
      if (selectedFilter) {
        selectedFilter['label'] = key
        selectedFilter['value'] = data
      }

      if(make_call){
        // Use ref to get latest pageSettings
        setPageSettings({
          ...pageSettingsRef.current,
          page:1,
          filters: _filters
        })
      }

      return _filters
    })
    if(!make_call){
      setIsFilterDirty(true)
    }
  }, 500)

  const handleDateChange = (data, key, make_call=false) => {

    console.log("---filterssss--->>>>", [...filters])
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }

  // Clear All only resets the draft fields inside the drawer - it must
  // NOT trigger a search. The actual API call happens when the user
  // clicks Apply Filters. If anything was set beforehand (applied or
  // just drafted), Apply lights up so the user can submit the reset.
  const handleClearAll = () => {
    const hadValues = filters.some(filter => filter.key !== "search" && (Array.isArray(filter.value) ? filter.value.length > 0 : !!filter.value))
    let clearedFilters = filters.map(filter => ({
      ...filter,
      value: "",
      label: filter.key === "search" ? "Search term" : (filter.key === "employment_date_after" ? "Joined after" : filter.key === "employment_date_before" ? "Joined before" : filter.key === "resigned_date_after" ? "Resigned after" : filter.key === "resigned_date_before" ? "Resigned before" : "")
    }))
    setFilters(clearedFilters)
    if(hadValues){
      setIsFilterDirty(true)
    }
  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty, setIsFilterDirty
  };
}
